// src/pages/hire-expert/WebDeveloper.jsx
import React, { useState } from "react";
//import Navbar from "../../components/Navbar";
//import Navbar from "../../components/navbar/Navbar";
//import Footer from "../../components/footer/Footer";
//import Footer from "../../components/Footer";
import "./HireExpert.css";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";

const WebDeveloper = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}, we’ll contact you soon!`);
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <>
      {/* Navbar */}
      <Navbar />

      <div className="hire-expert-container">
        {/* Hero Section */}
        <header className="hero-section">
          <h1>Hire Web Developers</h1>
          <p>
            Build responsive, scalable, and secure websites with our expert web
            developers. We specialize in frontend, backend, and full-stack
            solutions tailored to your business growth.
          </p>
          <button
            className="cta"
            onClick={() =>
              document
                .getElementById("contact-form")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Book a Call
          </button>
          
        </header>

        {/* Stats Section */}
        <section className="stats">
          <div>
            <h2>32+</h2>
            <p>Countries Served</p>
          </div>
          <div>
            <h2>125+</h2>
            <p>In-house Experts</p>
          </div>
          <div>
            <h2>1870+</h2>
            <p>Projects Delivered</p>
          </div>
          <div>
            <h2>10+</h2>
            <p>Years Experience</p>
          </div>
        </section>

        {/* Tech Stack */}
        <section className="info-section">
          <h2>Technology Stack</h2>
          <ul>
            <li>Frontend: HTML, CSS, JavaScript, React, Angular, Vue.js</li>
            <li>
              Backend: Node.js, Express, PHP, Python (Django/Flask), Java
              (Spring)
            </li>
            <li>Databases: MySQL, MongoDB, PostgreSQL, Firebase</li>
            <li>Cloud: AWS, Azure, Google Cloud</li>
            <li>Tools: Git, Docker, CI/CD</li>
          </ul>
        </section>

        {/* Best Practices */}
        <section className="info-section">
          <h2>Best Practices We Follow</h2>
          <ul>
            <li>Clean, maintainable, and scalable code</li>
            <li>Responsive and cross-browser compatibility</li>
            <li>SEO-friendly development</li>
            <li>Security-first approach</li>
            <li>Agile methodology and continuous delivery</li>
          </ul>
        </section>

        {/* Services */}
        <section className="info-section">
          <h2>Our Web Development Services</h2>
          <ul className="services-list">
            <li>Custom Website Development</li>
            <li>Full-Stack Web Development</li>
            <li>E-commerce Development (Shopify, WooCommerce, Magento)</li>
            <li>CMS Development (WordPress, Drupal)</li>
            <li>Web App Development</li>
            <li>Website Migration & Optimization</li>
            <li>Maintenance & Support</li>
          </ul>
        </section>

        {/* Contact Form */}
        <section id="contact-form" className="contact-section">
          <h2>Book a Call / Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Tell us about your project..."
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
            ></textarea>
            <button type="submit" className="cta">
              Send Message
            </button>
          </form>
        </section>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default WebDeveloper;
